// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-api-page-js": () => import("/usr/local/lib/node_modules/tui-doc/src/templates/api-page.js" /* webpackChunkName: "component---src-templates-api-page-js" */),
  "component---src-templates-example-page-js": () => import("/usr/local/lib/node_modules/tui-doc/src/templates/example-page.js" /* webpackChunkName: "component---src-templates-example-page-js" */),
  "component---src-pages-index-js": () => import("/usr/local/lib/node_modules/tui-doc/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("/usr/local/lib/node_modules/tui-doc/.cache/data.json")

